/**
 * La synchronisation du layout LiveKit (POST /layout) n'a de sens que pendant un live : hors
 * IN_PROGRESS il n'y a pas de room, et l'API répondait 500 LAYOUT.UPDATE_FAILED. On se fie au
 * statut back de la session courante, et seulement si c'est bien la session visée (le state peut
 * porter la session d'une régie visitée avant).
 */
export function shouldSyncLiveKitLayout(
  currentSession: { id: number; status: string } | null | undefined,
  sessionId: number,
  camLayoutOnly = false,
): boolean {
  if (currentSession?.id !== sessionId) return false;
  // La mise en page caméras se règle aussi avant le direct : le back répond 204 sans rien écrire
  // tant que la room n'existe pas, et la régie rejoue alors son choix à la création de la room.
  return camLayoutOnly || currentSession.status === 'IN_PROGRESS';
}
